// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"3a50c40c","255":"0215e6fe","393":"5e01afe9","474":"3b5b2c03","580":"68a90cdc","874":"cd83e9de","965":"2a8ca2f3","994":"29117546"}[chunkId] + ".chunk.js";
};